import { render, staticRenderFns } from "./WorkplaceStatistics.vue?vue&type=template&id=12d03a1a&"
import script from "./WorkplaceStatistics.vue?vue&type=script&lang=js&"
export * from "./WorkplaceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports